import type { CategoryLocaleEntry, CategoryPageLocaleCopy } from '../types'

export const categoryPageCopyEn: CategoryPageLocaleCopy = {
  notFound: 'Category not found',
  backHome: 'Back to Home',
  breadcrumbHome: 'Home',
  fallbackToolsTitle: 'Free Online Tools',
}

export const categoryContentEn: Record<string, CategoryLocaleEntry> = {
  electrical: {
    h1: '⚡ Electrical Calculators',
    seoTitle: "Electrical Calculators - Ohm's Law, Voltage, Current & Power",
    seoDescription: "Free electrical calculators for Ohm's Law, voltage dividers, power, resistance, RC circuits, impedance, voltage drop and more.",
    intro: 'Free electrical engineering calculators for circuits, components and power systems. Whether you are designing a circuit, troubleshooting a component, or learning electronics, these tools give you instant, accurate results.',
  },
  energy: {
    h1: '🔋 Energy Calculators',
    seoTitle: 'Energy Calculators - Battery, Solar, EV & Electricity Cost',
    seoDescription: 'Free energy calculators for battery runtime, battery capacity, solar panel output, EV charging cost, electricity bills and more.',
    intro: 'Calculate battery life, solar energy output, EV charging costs and electricity bills. Practical energy calculators for homeowners, engineers and EV owners.',
  },
  mechanical: {
    h1: '⚙️ Mechanical Calculators',
    seoTitle: 'Mechanical Engineering Calculators - Torque, Gear Ratio, Power & Force',
    seoDescription: 'Free mechanical engineering calculators for torque, gear ratio, mechanical power, horsepower, pressure and force.',
    intro: 'Mechanical engineering calculators for forces, motion, power transmission and fluid systems. Calculate torque, gear ratios, power and pressure from first principles.',
  },
  thermal: {
    h1: '🌡️ Thermal Calculators',
    seoTitle: 'Thermal Engineering Calculators - Heat Transfer, Heat Loss & Thermal Resistance',
    seoDescription: 'Free thermal engineering calculators for heat transfer, heat loss, thermal resistance and thermal conductivity.',
    intro: 'Thermal engineering calculators for heat transfer, insulation, heatsink design and building energy analysis. Calculate conductive heat flow and thermal resistance.',
  },
  physics: {
    h1: '⚛️ Physics Calculators',
    seoTitle: 'Physics Calculators - Kinetic Energy, Momentum, Frequency & Wavelength',
    seoDescription: 'Free physics calculators for kinetic energy, potential energy, momentum, frequency and wavelength.',
    intro: 'Physics calculators for mechanics, waves and energy. Calculate kinetic and potential energy, momentum, and wave frequency and wavelength.',
  },
  math: {
    h1: '🔢 Math Calculators',
    seoTitle: 'Math Calculators - Percentage, Average, Area, Volume & More',
    seoDescription: 'Free math calculators for percentages, averages, areas, volumes, fractions, Pythagorean theorem and more.',
    intro: 'Practical math calculators for everyday calculations. Find percentages, calculate averages, compute areas and volumes, work with fractions and solve geometry problems.',
  },
  converters: {
    h1: '🔄 Converters',
    seoTitle: 'Free Online Converters - Unit, JSON, Base64, CSV & URL',
    seoDescription: 'Free online converters for units, JSON/YAML, Base64, number bases, URL encoding and CSV/JSON. All run in your browser.',
    intro: 'Fast, free online converters for engineers, developers and everyday use. Convert units, transform data formats, encode and decode text - everything runs in your browser.',
  },
  tools: {
    h1: '🛠️ Tools',
    seoTitle: "Free Online Tools - IP, Subnet, Regex, Colour, Hash & Timestamp",
    seoDescription: "Free online tools including subnet calculator, what's my IP, regex tester, colour converter, hash generator and Unix timestamp converter.",
    intro: 'Useful developer and network tools available free in your browser. Find your public IP, calculate subnets, test regular expressions, generate hashes and convert Unix timestamps.',
  },
  generators: {
    h1: '✨ Generators',
    seoTitle: 'Free Online Generators - Password, UUID & Lorem Ipsum',
    seoDescription: 'Free online generators for secure passwords, UUIDs and Lorem Ipsum placeholder text. All run entirely in your browser.',
    intro: 'Generate passwords, UUIDs and placeholder text instantly. Everything runs in your browser - no data is sent to any server.',
  },
  finance: {
    h1: '💰 Finance Calculators',
    seoTitle: 'Finance Calculators - Compound Interest, VAT, Loans & More',
    seoDescription: 'Free finance calculators for compound interest, VAT, loan payments, discounts, salary conversion and ROI. Quick and accurate.',
    intro: 'Financial calculators for everyday money decisions. Calculate VAT, work out loan repayments, convert salary to hourly rate, or find the true cost of a discount.',
  },
  health: {
    h1: '❤️ Health & Fitness Calculators',
    seoTitle: 'Health Calculators - BMI, BMR, TDEE & Body Fat',
    seoDescription: 'Free health and fitness calculators for BMI, Basal Metabolic Rate, TDEE and body fat percentage.',
    intro: 'Health and fitness calculators to help you understand your body. Calculate BMI, basal metabolic rate, calorie needs, and body fat percentage.',
  },
  everyday: {
    h1: '🏠 Everyday Calculators',
    seoTitle: 'Everyday Calculators - Tip, Fuel, Age, Date & Paint',
    seoDescription: 'Free everyday calculators for tips, fuel costs, age, date differences and paint coverage. Practical tools for daily use.',
    intro: 'Practical calculators for everyday tasks. Split a restaurant bill, calculate the fuel cost of a journey, find out your exact age, or work out how much paint you need.',
  },
  science: {
    h1: '🔬 Science Calculators',
    seoTitle: 'Science Calculators - Gas Laws, Density, pH, Half-Life & More',
    seoDescription: 'Free science calculators covering ideal gas law, density, pH, half-life, centripetal force, optics and more.',
    intro: 'Science calculators for chemistry, physics and applied science. Calculate gas pressure and volume, find pH from concentration, work out radioactive decay, and more.',
  },
  environmental: {
    h1: '🌍 Environmental Calculators',
    seoTitle: 'Environmental Calculators - Carbon Footprint, Solar ROI & More',
    seoDescription: 'Free environmental calculators for carbon footprint, solar panel ROI, EV vs petrol cost comparison and rainwater harvesting.',
    intro: 'Environmental and sustainability calculators. Estimate your carbon footprint, compare electric vs petrol running costs, calculate solar panel payback, and more.',
  },
}
